<div *ngIf="mostrarBloqueo" class="maintenance-lock" role="alert" aria-live="assertive">
  <main class="maintenance-shell">
    <header class="maintenance-intro">
      <div class="status-label">Servicio temporalmente no disponible</div>
      <h1>La plataforma está en mantenimiento</h1>
      <p>{{ mantenimientoActivo.mensaje }}</p>
    </header>

    <section class="window-panel">
      <div class="panel-heading">
        <i class="material-icons" aria-hidden="true">schedule</i>
        <span>Ventana de mantenimiento</span>
      </div>

      <div class="window-progress">
        <div class="countdown-block">
          <strong>{{ tiempoRestante }}</strong>
          <span>Tiempo restante estimado</span>
        </div>
        <div class="progress-block">
          <div class="progress-track" role="progressbar" [attr.aria-valuenow]="porcentajeAvance"
            aria-valuemin="0" aria-valuemax="100">
            <span [style.width.%]="porcentajeAvance"></span>
          </div>
          <div class="progress-labels">
            <span>Inicio {{ formatearHora(mantenimientoActivo.fechaInicio) }}</span>
            <span>Fin estimado {{ formatearHora(mantenimientoActivo.fechaFin) }}</span>
          </div>
        </div>
      </div>

      <dl class="window-details">
        <div class="detail-row">
          <dt>Inicio</dt>
          <dd>{{ formatearFecha(mantenimientoActivo.fechaInicio) }} (GMT-5)</dd>
        </div>
        <div class="detail-row">
          <dt>Fin estimado</dt>
          <dd>{{ formatearFecha(mantenimientoActivo.fechaFin) }} (GMT-5)</dd>
        </div>
        <div class="detail-row">
          <dt>Duración</dt>
          <dd>{{ duracionTexto }}</dd>
        </div>
        <div class="detail-row">
          <dt>Referencia</dt>
          <dd class="reference-value">{{ referencia }}</dd>
        </div>
      </dl>

      <div class="scope-row">
        <span>Alcance</span>
        <strong>Acceso general a la plataforma temporalmente suspendido</strong>
      </div>
    </section>

    <aside class="maintenance-note">
      <i class="material-icons" aria-hidden="true">info_outline</i>
      <p>El acceso se restablecerá automáticamente cuando finalice la ventana. No es necesario cerrar esta pestaña.</p>
    </aside>

    <footer class="maintenance-footer">
      <button type="button" class="retry-button" (click)="reintentar()">
        <i class="material-icons" aria-hidden="true">refresh</i>
        Reintentar
      </button>
      <span>Horario oficial: America/Guayaquil</span>
    </footer>
  </main>
</div>
